export const APP_VERSION = import.meta.env?.APP_VERSION ?? 'unknown';
